import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import {
  selectAction,
  selectCarousel,
  selectCondition,
  selectNode,
  selectRequisite,
} from '@/redux/nodes/actions';
import { DialogAlert } from '@/shared/types/dialogAlert';
import { scrollToElementById } from '@/util/util';

const useAlertNavigation = () => {
  const dispatch = useDispatch();

  const openToolkit = useCallback(
    ({ id, type, ...rest }: DialogAlert) => {
      switch (type) {
        case 'carousel':
          dispatch(selectCarousel({ actionId: id, index: rest.cardIndex }));
          break;
        case 'question':
          dispatch(selectRequisite({ nodeId: rest.nodeId, index: rest.index, requisiteId: id }));
          break;
        case 'condition':
          dispatch(selectCondition({ nodeId: rest.nodeId, index: rest.index }));
          break;
        case 'event':
        case 'intent':
          dispatch(selectNode({ nodeId: id }));
          break;
        default:
          dispatch(selectAction({ actionId: id }));
      }
    },
    [dispatch]
  );

  const handleAlertClick = useCallback(
    (selectedDialogAlert: DialogAlert) => {
      setTimeout(() => {
        scrollToElementById(selectedDialogAlert.id);
        openToolkit(selectedDialogAlert);
      }, 0);
    },
    [openToolkit]
  );

  return { handleAlertClick };
};

export default useAlertNavigation;
